// /src/pages/private/admin/PrivateDocuments/donatorPerks/donatorPerksApi.js

import axios from 'axios';

export async function fetchDonatorPerksAdmin() {
  const res = await axios.get('/api/admin/privatedocuments/donator-perks', { withCredentials: true });
  return res.data;
}

export async function saveDonatorPerks(payload) {
  const res = await axios.put('/api/admin/privatedocuments/donator-perks', payload, { withCredentials: true });
  return res.data;
}

export async function fetchDonatorPerksPublic() {
  const res = await axios.get('/api/public/donator-perks');
  return res.data;
}
